import {useState, useEffect} from 'react';
import logo from './sgassistlogo.png';
import './App.css';

const App = () => {  
  //set and store the selected from radio buttons
  const [assistance, setAssistance] = useState("");
  const [category, setCategory] = useState("");
  const [urgency, setUrgency] = useState("");

  //set and store possible selections to generate radio buttons
  const [assistanceList, setAssistanceList] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [urgencyList, setUrgencyList] = useState([]);

  //array storing parsed config csv file (each form and its details, links)
  const [mainArray, setMainArray] = useState([]);

  //array storing all the forms that match selected criteria
  const [form, setForm] = useState([]);

  //form chosen after filtering through available options within this criteria 
  const [chosenForm, setChosenForm] = useState({});

  //map to quantify the urgency of each request to generate based on days leading up to the cutoff, rather than 1 to 1 mapping of time
  const [urgencyMap, setUrgencyMap] = useState({});

  //function that parses the csv config file into an array
  const processCSV = (str, delim=',') => {
        //splits first row into column headings by the commas
        const headers = str.slice(0,str.indexOf('\n')).split(delim);
        //splits data into array of rows
        const rows = str.slice(str.indexOf('\n')+1).split('\n');
        const newArray = rows.filter(Boolean).map( (row) => {
              const values = row.split(delim);
              const eachVal = headers.reduce((obj, header, i) => {
                  obj[header.trim()] = values[i];
                  return obj;
              }, {});
              return eachVal;
        });
        //stores array of parsed values into mainArray
        setMainArray(newArray);
        return newArray;
  }
  
  //function that obtains and stores values for the radio buttons
  const practiceDropdown = (arr) => {
    var assistanceList1 = [];
    var beneficiaryList1 = [];
    var urgencyList1 = [];
    var urgencyDays = [];
    for (let i=0; i<arr.length; i++) {
      //for all the rows, if values are not in the specific array, add them
      if (assistanceList1.indexOf(arr[i].Reimbursement)<=-1) {
        assistanceList1.push(arr[i].Reimbursement);
      };
      if (beneficiaryList1.indexOf(arr[i]['Target Support Group'])<=-1) {
        beneficiaryList1.push(arr[i]['Target Support Group']);
      };
      if (urgencyList1.indexOf(arr[i]['Processed By'])<=-1) {
        //storing both urgency in words and quantified in days
        urgencyList1.push(arr[i]['Processed By']);
        urgencyDays.push(parseInt(arr[i].Days));
      };
    };
    var tempMap = {};
    //map each urgency in words to the quantified days
    urgencyList1.forEach((key, i) => tempMap[key] = urgencyDays[i]);
    //store values for radio button in lists
    setAssistanceList(assistanceList1);
    setCategoryList(beneficiaryList1);
    setUrgencyList(urgencyList1);
    setUrgencyMap(tempMap);
  }
    
  //executing function everytime page is refreshed -> parsing csv, processing into radio buttons
  useEffect(() => {
    var result = [];
    fetch('./config/Links - Top 10 Forms.csv').then(response => response.text()).then(responseText => processCSV(responseText)).then(responseArr => practiceDropdown(responseArr));
  }, []);
  
  //executing everytime a different radio button is selected
  useEffect (() => {
    setForm([]);
    setChosenForm({});
    for (let i=0; i<mainArray.length; i++) {
      if (assistance === mainArray[i].Reimbursement) {
        if (category === mainArray[i]['Target Support Group']) {
          // if the urgency of the form is that the help is delivered before or within the requested
          // if the urgency days of the form is less than equal to requested
          // if it is negative, then time is not a constrant and all forms are rendered
          if ((parseInt(mainArray[i].Days)<= urgencyMap[urgency] && parseInt(mainArray[i].Days)>=0) || urgencyMap[urgency]<0) {
            //storing link, name, description, time taken for forms that match these criteria
            setForm(oldArray=> [...oldArray, {link: mainArray[i]['Links'], name: mainArray[i]['Form Name'], description: mainArray[i]['Additional Description'], time: mainArray[i]['Processing Time']}])
          }
        }
      }
    }
  }, [assistance, category, urgency]);

  return (
    <div className="App">
      <header className="App-header">
        <section class="container shadow col-11 section1">
          <img src={logo} alt="Care Assist" width="300px"/>
          <section class="shadow col-10">
            <nav class="navbar navbar-expand-lg navbar-light bg-light nbar">
              <div>
                <div class="formdiv">
                  <span class="formspan">Please fill the below form</span>
                </div>
              </div>
            </nav><br />
            <p class="textCenter"><b>Please refresh page for each new submission</b></p>
            <form>
              <p>1. Please select the required assistance*</p>
              <div>
                {assistanceList.map((option) => (
                  <span>
                    <input type="radio" name="assistance" id={option.replace(/\s/g, '')} value={option.replace(/\s/g, '')} onChange={e => { setAssistance(option); }} />
                    <label for={option.replace(/\s/g, '')}>{option}</label><br/>
                  </span>
                ))}
              </div>
              <br/>
              <p>2. Beneficiary Category*</p>
              <span class="italic"><i><b>Please select the most appropriate category for beneficiary</b></i></span><br/><br/>
              <div>
                {categoryList.map((option) => (
                  <span>
                    <input type="radio" name="category" id={option.replace(/\s/g, '')} value={option.replace(/\s/g, '')} onChange={e => { setCategory(option); }} />
                    <label for={option.replace(/\s/g, '')}>{option}</label><br/>
                  </span>
                ))}
              </div>
              <br />
              <p>3. When should this be processed by*</p>
              <span class="italic"><i><b>Based on urgency we will select the most suitable service provider</b></i></span><br/><br/>
              <div>
                {urgencyList.map((option) => (
                  <span>
                    <input type="radio" name="urgency" id={option.replace(/\s/g, '')} value={option.replace(/\s/g, '')} onChange={e => { setUrgency(option); }} />
                    <label for={option.replace(/\s/g, '')}>{option}</label><br/>
                  </span>
                ))}
              </div>
              <br />
            </form>
          </section><br/>
          {form.length == 1 && <h4>{form[0].name}<br /><small>{form[0].description}</small><br /><small><i>{form[0].time}</i></small></h4>}
          {form.length == 1 && <iframe className="forms" src={form[0].link} width="95%" height="1000px"></iframe>}
          {form.length > 1 && <h4>There are multiple forms matching this criteria. Which would you like to access?<br/><br/><br/></h4>}
          {form.length > 1 &&
            <div class="parentRadio">
              {form.map((option) => (
                <div class="radioButtons">
                  <input type="radio" name="chooseform" id={option.name.replace(/\s/g, '')} value={option.name.replace(/\s/g, '')} onChange={e => { setChosenForm(option); }} />
                  <label for={option.name.replace(/\s/g, '')}>{option.name}</label>
                  <br/>
                  <h5>{option.description}</h5>
                  <br/>
                </div>
              ))}
            </div>
          }
          {form.length > 1 && Object.keys(chosenForm).length != 0 && <h4>{chosenForm.name}<br /><small>{chosenForm.description}</small><br /><small><i>{chosenForm.time}</i></small></h4>}
          {form.length > 1 && Object.keys(chosenForm).length != 0 && <iframe className="forms" src={chosenForm.link} width="95%" height="1000px"></iframe>}
          {assistance && category && urgency && form.length == 0 && <iframe className="forms" src="https://forms.monday.com/forms/embed/8299af572f2e3e63408e22f44ef26a11?r=use1%22" width="95%" height="1000px"></iframe>}
        </section>
      </header>
    </div>
  );
}

export default App;
